import {Component, Inject, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {InstrumentModel} from '../../../interfaces/interfaces';


@Component({
  selector: 'app-model-selection-dialog',
  templateUrl: './model-selection-dialog.component.html'
})

export class ModelSelectionDialogComponent implements OnInit {
  modelCtrl = new FormControl('');
  public filteredModels: Observable<InstrumentModel[]> = new Observable<InstrumentModel[]>();

  // public data: { models: InstrumentModel[] } = inject(MAT_DIALOG_DATA);
  // public dialogRef: MatDialogRef<ModelSelectionDialogComponent, InstrumentModel> = inject(MatDialogRef);

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { models: InstrumentModel[] },
        public dialogRef: MatDialogRef<ModelSelectionDialogComponent, InstrumentModel>
    ) {}

  ngOnInit(): void {
    this.filteredModels = this.modelCtrl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    );
  }

  private _filter(value: string): InstrumentModel[] {
    const filterValue = value.toLowerCase();

    return this.data.models.filter(model => {
      const modelName = model.name.toLowerCase();
      const brandName = model.brand?.name?.toLowerCase() || '';

      return modelName.includes(filterValue) || brandName.includes(filterValue);
    });
  }

  displayFn = (model: InstrumentModel): string => {
    return model ? `${model.name} (${model.brand?.name || ''})` : '';
  }

  selectModel(): void {
    this.dialogRef.close(this.modelCtrl.value);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
